export const messages = {
  en: {
    shopSms: {
      purchaseSms: 'Purchase SMS',
      unitPrice: 'Unit Price',
      purchaseQuantity: 'Purchase Quantity',
      selectPurchaseQuantity: 'Please select purchase quantity',
      unit: 'pieces',
      paymentAmount: 'Payment Amount',
      paymentQrCode: 'Payment QR Code',
      purchased: 'Already Purchased'
    }
  },
  zh: {
    shopSms: {
      purchaseSms: '购买短信',
      unitPrice: '单价',
      purchaseQuantity: '购买数量',
      selectPurchaseQuantity: '请选择购买数量',
      unit: '条',
      paymentAmount: '支付金额',
      paymentQrCode: '支付二维码',
      purchased: '已购买'
    }
  }
} 